import React, { useEffect, useRef, useState } from "react";
import ButtonCompo from "../component/ButtonCompo";
import { MdCloudDownload } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { SERVER_URL } from "../constant";
import dayjs from "dayjs";
import { FaCamera } from "react-icons/fa";
import { LinearProgress } from "@mui/material";
import AlertBox from "../component/AlertBox";
import axios from "axios";
import { reloadToggle } from "../store/reload.slice";

function ProbationCheck({ probationPeriod, dateOfJoining }) {
  const [remainingDays, setRemainingDays] = useState(undefined);

  useEffect(() => {
    setRemainingDays(() => {
      // make a dayjs object of the given date
      const date = dayjs(dateOfJoining);
      // make a last date of probation period
      const lastDate = date.add(probationPeriod, "months");
      // check if the date has been passed or not
      const isPassed = dayjs().isAfter(lastDate);
      // find remaining months
      const remainingMonths = lastDate.diff(dayjs(), "months", true); // check all the params in dayjs

      return remainingMonths > 0 ? remainingMonths.toFixed(1) : 0;
    });
  }, [probationPeriod, dateOfJoining]);

  return (
    <p className="text-red-600 text-[15px]">{remainingDays} months left</p>
  );
}

function MyProfile() {
  const employeeData = useSelector((state) => state.employee?.employeeData);
  const profileImageRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [success, setSuccess] = useState(undefined);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch()

  console.log(employeeData);

  async function updateData(image) {
    const formData = new FormData();
    if (!image) {
      setOpen(true);
      setSuccess(false);
      setMessage("Please select a profile image");
      return null;
    }
    formData.append("logo", image);
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/employee/update`,
        method: "post",
        data: formData,
        withCredentials: true,
        headers: {
          "Content-Type": "multipart/form-data", // Axios automatically sets this
        },
      });
      dispatch(reloadToggle());
    } catch (error) {
      setOpen(true);
      setSuccess(false);
      setMessage(error?.response?.data?.message);
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      {loading && (
        <LinearProgress className="!fixed !top-0 !left-0 !right-0 !h-[8px]" />
      )}
      <div className="w-full flex flex-col justify-center items-center">
        {success !== undefined && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        <div className="w-[90vw] 2xl:w-[70vw] py-5 space-y-5">
          <div className="w-full p-5 rounded-[20px] space-y-10">
            <section className="flex justify-between items-center">
              <h1 className="text-[20px] border-l-[5px] border-teal-500 font-medium text-slate-700 pl-5">
                My Details
              </h1>
            </section>
            <div className="w-full flex flex-col lg:flex-row justify-start items-center gap-10">
              <section className="">
                <section className="w-[8rem] h-[8rem] relative">
                  <input
                    type="file"
                    className="hidden"
                    onChange={(e) => {
                      updateData(e?.target?.files[0]);
                    }}
                    ref={profileImageRef}
                  />
                  <img
                    src={`${SERVER_URL}/api/v1/file/view/${employeeData?.logo}`}
                    className="w-full h-full object-cover rounded-full"
                    alt=""
                  />
                  <section className="bg-sky-500 absolute bottom-3 left-[80%] p-2 rounded-full">
                    <FaCamera
                      className="text-[20px] text-white cursor-pointer"
                      onClick={() => profileImageRef.current.click()}
                    />
                  </section>
                </section>
              </section>
              <section className="text-slate-900 w-full">
                <p className="text-[20px] font-medium">
                  {employeeData?.fullName}
                </p>
                <section className="flex flex-col md:flex-row gap-[1rem] md:gap-[3rem] mt-5">
                  <div>
                    <p className="text-slate-500">Role</p>
                    <p className="font-medium">{employeeData?.role}</p>
                  </div>
                  <div>
                    <p className="text-slate-500">Phone</p>
                    <p className="font-medium">{employeeData?.phoneNumber}</p>
                  </div>
                  <div>
                    <p className="text-slate-500">Email</p>
                    <p className="font-medium truncate">
                      {employeeData?.profEmail}
                    </p>
                  </div>
                </section>
              </section>
            </div>
          </div>
          <div className="w-full p-5 rounded-[20px] space-y-10">
            <h1 className="text-[20px] border-l-[5px] border-teal-500 font-medium text-slate-700 pl-5">
              Job Details
            </h1>
            <section className="w-full grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-5 gap-5">
              <div>
                <p className="text-slate-500 text-[15px] font-normal">
                  Employee ID
                </p>
                <p className="text-[13px] sm:text-[14px] text-slate-800 font-medium mt-2">
                  {employeeData?.employeeId}
                </p>
              </div>
              <div>
                <p className="text-slate-500 text-[15px] font-normal">
                  Date of Joining
                </p>
                <p className="text-[13px] sm:text-[14px] text-slate-800 font-medium mt-2">
                  {new Date(employeeData?.onBoardingDate).toLocaleDateString()}
                </p>
              </div>
              <div>
                <p className="text-slate-500 text-[15px] font-normal">
                  Probation Period
                </p>
                <p className="text-[13px] sm:text-[14px] text-slate-800 font-medium mt-2">
                  {employeeData?.probationPeriod} months{" "}
                  <span>
                    <ProbationCheck
                      probationPeriod={employeeData?.probationPeriod}
                      dateOfJoining={employeeData?.onBoardingDate}
                    />
                  </span>
                </p>
              </div>
              <div>
                <p className="text-slate-500 text-[15px] font-normal">CTC</p>
                <p className="text-[13px] sm:text-[14px] text-slate-800 font-medium mt-2">
                  Rs. {employeeData?.ctc}
                </p>
              </div>
              <div>
                <p className="text-slate-500 text-[15px] font-normal">
                  Department
                </p>
                <p className="text-[13px] sm:text-[14px] text-slate-800 font-medium mt-2">
                  {employeeData?.department}
                </p>
              </div>
              <div>
                <p className="text-slate-500 text-[15px] font-normal">
                  Designation
                </p>
                <p className="text-[13px] sm:text-[14px] text-slate-800 font-medium mt-2">
                  {employeeData?.designation}
                </p>
              </div>
              <div>
                <p className="text-slate-500 text-[15px] font-normal">Gender</p>
                <p className="text-[13px] sm:text-[14px] text-slate-800 font-medium mt-2">
                  {employeeData?.gender}
                </p>
              </div>
              <div>
                <p className="text-slate-500 text-[15px] font-normal">
                  Personal Email
                </p>
                <p className="text-[13px] sm:text-[14px] text-slate-800 font-medium mt-2">
                  {employeeData?.gmail}
                </p>
              </div>
              <div>
                <p className="text-slate-500 text-[15px] font-normal">
                  Project Name
                </p>
                <p className="text-[13px] sm:text-[14px] text-slate-800 font-medium mt-2">
                  {employeeData?.project}
                </p>
              </div>
            </section>
          </div>
          <div className="w-full p-5 rounded-[20px] space-y-10">
            <h1 className="text-[20px] border-l-[5px] border-teal-500 font-medium text-slate-700 pl-5">
              Personal Details
            </h1>
            <section className="w-full grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-5 gap-5">
              <div>
                <p className="text-slate-500 text-[15px] font-normal">
                  Highest Education
                </p>
                <p className="text-[13px] sm:text-[14px] text-slate-800 font-medium mt-2">
                  {employeeData?.highestEdu}
                </p>
              </div>
              <div>
                <p className="text-slate-500 text-[15px] font-normal">
                  Experience
                </p>
                <p className="text-[13px] sm:text-[14px] text-slate-800 font-medium mt-2">
                  {employeeData?.experience}
                </p>
              </div>
              <div>
                <p className="text-slate-500 text-[15px] font-normal">Skills</p>
                <section className="mt-2 w-full flex flex-wrap gap-1">
                  {employeeData?.skills?.split(",").map((e, i) => (
                    <span className="bg-sky-300/30 text-sky-800 px-2 py-1 text-[13px] rounded-full font-medium">
                      {e}
                    </span>
                  ))}
                </section>
              </div>
              <div>
                <p className="text-slate-500 text-[15px] font-normal">
                  Secendory Skills
                </p>
                <section className="mt-2 w-full flex flex-wrap gap-1">
                  {employeeData?.seconderySkills?.split(",").map((e, i) => (
                    <span className="bg-sky-300/30 text-sky-800 px-2 py-1 text-[13px] rounded-full font-medium">
                      {e}
                    </span>
                  ))}
                </section>
              </div>
              <div>
                <p className="text-slate-500 text-[15px] font-normal">CV</p>
                <p className="text-[13px] sm:text-[14px] text-slate-800 font-medium mt-2 flex items-center gap-2">
                  Uploaded{" "}
                  <ButtonCompo
                    sx={{
                      "min-width": "auto",
                      padding: "0",
                      "margin-left": "3px",
                    }}
                  >
                    <MdCloudDownload size={"23px"} />
                  </ButtonCompo>
                </p>
              </div>
              <div>
                <p className="text-slate-500 text-[15px] font-normal">
                  Offer Letter
                </p>
                <p className="text-[13px] sm:text-[14px] text-slate-800 font-medium mt-2 flex items-center gap-2">
                  Uploaded{" "}
                  <ButtonCompo
                    sx={{
                      "min-width": "auto",
                      padding: "0",
                      "margin-left": "3px",
                    }}
                  >
                    <MdCloudDownload size={"23px"} />
                  </ButtonCompo>
                </p>
              </div>
            </section>
          </div>
        </div>
      </div>
    </>
  );
}

export default MyProfile;
